import { convertMeasurement, measurementUnit, resolveMeasurementSystem } from './measurement'
import { measurementItem } from './measurementView'

import type { OptimizationRun } from '../types/optimization'

export function getFloorPressureStatus(run: OptimizationRun) {
  const fp = run.result?.floorPressure
  const policy = fp?.policy ?? run.input?.constraints?.floorPressurePolicy ?? 'strict'
  const exceeded = fp?.assessment === 'exceeded' || (fp?.itemsOverLimit ?? 0) > 0 || !!fp?.exceedances?.length
  const assessment = fp?.assessment ?? (exceeded ? 'exceeded' : fp?.isValid === true ? 'within_limit' : 'unverified')
  const notice = assessment === 'unverified'
    ? 'Conformité de pression non vérifiée'
    : exceeded
      ? `${policy === 'simulation' ? 'Simulation — ' : ''}Limite de pression dépassée — à résoudre avant exécution`
      : policy === 'simulation' ? 'Simulation — limite de pression respectée' : ''
  return { policy, assessment, notice }
}

export function buildPlacementCsv(run: OptimizationRun): string {
  const status = getFloorPressureStatus(run)
  const fp = run.result?.floorPressure
  const system = resolveMeasurementSystem(run.input?.measurement_system)
  const cargo = measurementUnit(system, 'cargoLength'), distance = measurementUnit(system, 'vehicleLength'), mass = measurementUnit(system, 'mass')
  const length = (v: number) => convertMeasurement(v, 'mm', cargo)
  const position = (v: number) => convertMeasurement(v, 'mm', distance)
  const weight = (p: any) => {
    const item = run.input?.items?.find(i => i.id === (p.item_id ?? p.itemId))
    const kg = p.weight ?? (item ? measurementItem(item).weight : null)
    return kg == null ? '' : convertMeasurement(kg, 'kg', mass)
  }
  const headers = ['item_id', `x_${distance}`, `y_${distance}`, `z_${distance}`, `length_${cargo}`, `width_${cargo}`, `height_${cargo}`, `weight_${mass}`, 'rotation',
    'floor_pressure_policy', 'floor_pressure_assessment', 'floor_pressure_limit_kg_m2',
    'floor_pressure_max_kg_m2', 'floor_pressure_notice']
  const rows = (run.result?.placements ?? []).map((p: any) => [
    p.item_id ?? p.itemId ?? '', position(p.position_x ?? p.position?.x ?? p.x ?? 0), position(p.position_y ?? p.position?.y ?? p.y ?? 0),
    position(p.position_z ?? p.position?.z ?? p.z ?? 0), length(p.length ?? 0), length(p.width ?? 0), length(p.height ?? 0),
    weight(p), typeof p.rotation === 'object' ? JSON.stringify(p.rotation) : p.rotation ?? 0,
    status.policy, status.assessment, fp?.maxPressure ?? '', fp?.maxObservedPressure ?? '', status.notice
  ])
  const escape = (value: unknown) => `"${String(value ?? '').replace(/"/g, '""')}"`
  return [headers, ...rows].map(row => row.map(escape).join(',')).join('\n')
}
